import { createContext } from "react"

const InvoiceDescriptionFormContext = createContext()

export default InvoiceDescriptionFormContext
